import { Injectable } from '@angular/core';
import { AppSettings } from '../app-settings';
import { catchError, map, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CitylokApiService {
  constructor(private http: HttpClient) {}

  checkHiddenCode(code: any, session: number) {
    const url = `${AppSettings.API_URI_V2}/blocked-seats/session/${session}/code/${code}`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      })
    );
  }

  getSessionBlockedSeatGroups(sessionId: number) {
    const url = `${AppSettings.API_URI_V2}/sessions/${sessionId}/blocked-seat-groups`;
    return this.http.get<any>(url).pipe(
      map((data) => data),
      catchError((err) => throwError(() => err))
    );
  }

  unlockMultipleBlockedSeats(sessionId: number, ids: number[]) {
    const url = `${AppSettings.API_URI_V2}/sessions/${sessionId}/blocked-seats-unlock`;
    return this.http.post<any>(url, { ids }).pipe(
      map((data) => data),
      catchError((err) => throwError(() => err))
    );
  }

  getPriceTickets(booking: any) {
    const url = `${AppSettings.API_URI_V2}/get/price/tpv`;
    return this.http.post<any>(url, booking).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        return throwError(() => err);
      })
    );
  }
}
